import { Button } from 'antd';
import React, { FC } from 'react';

import styles from './textMenu.module.scss';

type Props = {
	onOkAddText: (evt: React.MouseEvent<HTMLElement>) => void;
};

const TextWindowFooter: FC<Props> = ({ onOkAddText }) => (
	<div className={styles.textWindowFooter}>
		<div>{_('TextWindowFooterText')}</div>
		<Button htmlType='button' id='okButton' type='primary' onClick={onOkAddText}>
			{_('Ok')}
		</Button>
	</div>
);

export { TextWindowFooter };
